<template>
  <div class="my-3">
    <div class="upload-Wrapper d-flex align-items-end">
      <div v-if="bannerImageUrl.length" class="w-100 banner-image">
        <img :src="bannerImageUrl[0]" />
        <CButton :disabled="loading" @click="onRemoveImage">
          <CIcon name="cil-x-circle" />
        </CButton>
      </div>
      <label for="uploadImage" class="ml-2">
        <div class="text-xs">{{ title }}</div>
        <span class="Upload-file mt-2">
          <CIcon name="cil-cloud-upload" />
        </span>
      </label>
      <input
        type="file"
        name="uploadImage"
        id="uploadImage"
        @input="uploadImage"
      />
    </div>
    <div v-if="progressPercent > 0">
      <CProgress
        :value="progressPercent"
        color="success"
        striped
        animated
        showPercentage
        :max="100"
      />
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  props: {
    value: {
      type: Array,
    },
    cat: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      progressPercent: 0,
      urlImage: [],
    };
  },
  computed: {
    bannerImageUrl: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    updateValue(percent) {
      this.progressPercent = percent;
    },
    async addImageUrl(formData, onProgress) {
      try {
        let config = {
          onUploadProgress(progressEvent) {
            try {
              document.getElementById("uploadImage").disabled = true;
              var percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              // this.progressPercent = percentCompleted;

              // execute the callback
              onProgress(percentCompleted);
            } catch (error) {
              console.log("error", error);
            }
            return percentCompleted;
          },
        };
        const { data } = await axios.post("/file", formData, config);
        this.urlImage.unshift(data.url);
        this.$emit("upload-image", this.urlImage);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.progressPercent = 0;
        document.getElementById("uploadImage").disabled = false;
      }
    },
    uploadImage(event) {
      try {
        let inputData = event.target.files[0];

        let name = inputData.name.split(".");

        var formData = new FormData();
        formData.append("file", inputData);
        formData.append("cat", this.cat);
        formData.append("suffix", name[name.length - 1]);

        this.addImageUrl(formData, this.updateValue);
      } catch (error) {
        console.log("error", error);
      }
    },
    onRemoveImage() {
      this.bannerImageUrl.splice(0, this.bannerImageUrl.length);
      this.urlImage.splice(0, this.urlImage.length);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-Wrapper {
  flex-wrap: wrap;
  max-width: 100%;
  input[type="file"] {
    display: none;
  }
  .Upload-file {
    display: inline-block;
    width: 65px;
    height: 65px;
    border: 1px solid #9da5b1;
    color: #9da5b1;
    text-align: center;
    line-height: 65px;
    cursor: pointer;

    border-radius: 8px;
    .c-icon {
      width: 2rem;
      height: 2rem;
    }
  }
  .download-file {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 65px;
    height: 65px;
    border: 1px solid #9da5b1;
    color: #9da5b1;
    text-align: center;
    line-height: 65px;
    cursor: pointer;
    border-radius: 8px;
    .c-icon {
      width: 2rem;
      height: 2rem;
    }
    .clear-badge {
      position: absolute;
      right: -11px;
      top: -11px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: #4f5d73c4;
      line-height: 24px;
      font-size: 1.3125rem;
      text-align: center;
      .btn {
        padding: 0;
        border: 0;
        width: 100%;
        color: white;
      }
    }
  }
  .banner-image {
    position: relative;
    img {
      width: 100%;
      height: 150px;
      border-radius: 8px;
      object-fit: cover;
      margin-bottom: 4px;
      &:hover {
        opacity: 0.5;
      }
    }
    &:hover .c-icon {
      display: block;
    }
    .c-icon {
      display: none;
      width: 3rem;
      height: 3rem;
      color: #0021479d;
      z-index: 3;
    }
    .btn {
      padding: 0;
      position: absolute;
      top: calc(50% - 1.5rem);
      right: calc(50% - 1.5rem);
      outline: none;
      border: none;
    }
  }
}
</style>
